module.exports = __webpack_public_path__ + "static/laura_04-5ae71817438dc89a7103dc5c7801d16b.jpg";